import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import FixtureQuickSummary from './components/FixtureQuickSummary/FixtureQuickSummary';
import './Fixture.scss';
import FixtureEditEvaluation from './FixtureEditEvaluation';
import FixtureEditInvoice from './FixtureEditInvoice';
import FixtureInput from './FixtureInput';
import FixtureSearch from './FixtureSearch';
import FixtureTable from './FixtureTable';
import { FixtureEvaluationInputSelector } from './reducers/FixtureEvaluationInputReducer';
import { FixtureInputSelector, setTriggerRefreshInput, setTriggerSave } from './reducers/FixtureInputReducer';
import { FixtureInvoiceInputSelector } from './reducers/FixtureInvoiceInputReducer';
import { resetFixtureSearch, setTriggerFixtureSearch } from './reducers/FixtureSearchReducer';
import { BrokerAccountSearchSelector } from '../BrokerAccount/reducers/BrokerAccountSearchReducer';
import BrokerAccount from '../BrokerAccount/BrokerAccount';

let triggerHotkeyAlready = false;

const Fixture: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const fixtureInputSelector = useSelector(FixtureInputSelector);
    const fixtureInvoiceInputSelector = useSelector(FixtureInvoiceInputSelector);
    const fixtureEvaluationInputSelector = useSelector(FixtureEvaluationInputSelector);
    const brokerAccountSearchModel = useSelector(BrokerAccountSearchSelector);

    useEffect(() => {
        document.title = "Fixture";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);

        dispatch(setTriggerFixtureSearch((new Date()).getTime()));
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        dispatch(setTriggerSave((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        dispatch(setTriggerFixtureSearch((new Date()).getTime()));
                        triggerHotkeyAlready = true;
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetFixtureSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 1500);
        }
    }, []);

    return (
        <>
            {
                fixtureInputSelector.showInputPanel &&
                <FixtureInput></FixtureInput>
            }
            {
                fixtureInvoiceInputSelector.showInvoiceInputPanel &&
                <FixtureEditInvoice></FixtureEditInvoice>
            }
            {
                fixtureEvaluationInputSelector.showEvaluationInputPanel &&
                <FixtureEditEvaluation></FixtureEditEvaluation>
            }
            {
                <Grid container className="fixture">
                    <Grid container className="fixture-search">
                        <FixtureSearch></FixtureSearch>
                    </Grid>
                    <Grid container className="datatable">
                        <FixtureTable></FixtureTable>
                    </Grid>
                </Grid>
            }
            <FixtureQuickSummary></FixtureQuickSummary>
        </>
    )
};

export default Fixture;